import makeCrud from '@/store/site/localization/crud'
export default makeCrud('system_variable')
